/* eslint-disable react/prop-types */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { DropdownButton, NavItem } from "react-bootstrap";
import {
  IoFolder,
  IoTrash,
  IoEllipsisVertical,
  IoTicket,
  IoDocument
} from "react-icons/io5";
import { find, isObject } from "lodash";
import ReactTable from "react-table";
import { Tooltip as ReactTooltip } from "react-tooltip";
import moment from "moment";

import * as customerActions from "../../actions/customerActions";
import * as contractActions from "../../actions/contractActions";
import * as projectActions from "../../actions/projectActions";
import * as departmentActions from "../../actions/departmentActions";
import * as codeActions from "../../actions/codeActions";
import * as userActions from "../../actions/userActions";

import ResponsiveDataComponent from "../common/ResponsiveDataComponent";
import Badge from "../common/Badge";

import Loading from "../common/Loading";

import { formatDate } from "../../helpers/date";

export const getClassName = (priority) => {
  if (priority === "Low") {
    return "success";
  }
  if (priority === "Normal") {
    return "warning";
  }
  return "danger";
};

class CallList extends Component {
  constructor(props) {
    super(props);
    this.state = { data: [] };
  }

  componentDidMount = () => {
    const { customers, contracts, departments, data, actions, users } =
      this.props;

    if (!customers.length) actions.loadCustomers();
    if (!contracts.length) actions.loadContracts();
    if (!departments.length) actions.loadDepartments();
    if (!users.length) actions.loadUsers();

    this.setState({ loading: true });
    if (data)
      this.setState({ data }, () =>
        setTimeout(() => this.setState({ loading: false }), 500)
      );

    if (this.props.reloadData) {
      this.props.reloadData(() => {
        this.table.fireFetchData();
      });
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.data !== this.props.data) {
      this.setState({ data: nextProps.data, loading: false });
    }
  };

  fetchData = async (state) => {
    const { pageSize, page, sorted, filtered } = state;

    this.props.fetchData({
      pageSize,
      page,
      sorted,
      filtered
    });

    this.setState({ loading: false });
  };

  render() {
    const {
      minimal,
      onClickView,
      onClickDelete,
      isMobile,
      users,
      customers,
      projects,
      codes,
      departments,
      pages,
      serverSide,
      filtered,
      sorted,
      auth,
      onPageSizeChange,
      defaultPageSize,
      fromProjectPage,
      ticketRedirect
    } = this.props;
    const { data, loading } = this.state;
    const status = {
      completed: codes.find(
        (c) => c.label === "Completed" && c.entity === "Call"
      ),
      reserved: codes.find((c) => c.label === "Reserved" && c.entity === "Call")
    };

    const call_type = codes.find(
      c => c.value === "PERSONAL" && c.entity === "Call"
    );

    const columns = !isMobile
      ? [
          {
            Header: "Status",
            accessor: "stage",
            // maxWidth: 150,
            className: "text-center",
            Cell: ({ value }) => {
              const stage = isObject(value)
                ? value
                : find(codes, { _id: value });
              return (
                <Badge
                  className="fixed-width"
                  color={stage ? stage.color : "#ccc"}
                >
                  {stage ? stage.label : "--"}
                </Badge>
              );
            }
          },
          {
            Header: "Priority",
            accessor: "priority",
            maxWidth: 150,
            className: "text-center",
            Cell: ({ value }) => {
              const stage = isObject(value)
                ? value
                : find(codes, { _id: value });
              const className = stage?.label ? getClassName(stage.label) : "";
              return stage ? (
                <Badge className={`fixed-width ${className}`}>
                  {stage ? stage.label : "--"}
                </Badge>
              ) : null;
            }
          },
          {
            Header: "Call Type",
            accessor: "call_type",
            maxWidth: 170,
            Cell: ({ value }) => {
              const callType = isObject(value)
                ? value
                : find(codes, { _id: value });
              return callType ? callType.label : "--";
            }
          },
          {
            Header: "Customer",
            accessor: "customer",
            maxWidth: 200,
            Cell: ({ value }) => {
              const customer = isObject(value)
                ? value
                : find(customers, { _id: value });
              return customer ? customer.name : "--";
            }
          },
          {
            Header: "Project",
            accessor: "project",
            maxWidth: 170,
            Cell: ({ value }) => {
              const project = isObject(value)
                ? value
                : find(projects, { _id: value });
              return project ? project.name : "--";
            }
          }
        ]
      : [
          {
            Header: "Tech",
            accessor: "assigned_to",
            maxWidth: 120,
            Cell: ({ value }) => {
              const user = find(users, {
                _id: isObject(value) ? value._id : value
              });

              return (
                <span style={user && !user.is_active ? { color: "red" } : null}>
                  {user ? user.full_name : "Unassigned"}
                </span>
              );
            }
          },
          {
            Header: "Project",
            accessor: "project",
            maxWidth: 150,
            Cell: ({ value }) => {
              const project = isObject(value)
                ? value
                : find(projects, { _id: value });
              return project ? project.name : "--";
            }
          }
        ];

    if (fromProjectPage) {
      columns.splice(
        -1,
        columns.findIndex((c) => c.Header === "Project")
      );
      columns.splice(
        -1,
        columns.findIndex((c) => c.Header === "Customer")
      );
    }
    if (!minimal && !isMobile) {
      columns.splice(2, 0, {
        Header: "Tech",
        // maxWidth: 170,
        accessor: "assigned_to",
        Cell: ({ value }) => {
          const user = find(users, {
            _id: isObject(value) ? value._id : value
          });

          return (
            <span style={user && !user.is_active ? { color: "red" } : null}>
              {user ? user.full_name : "Unassigned"}
            </span>
          );
        }
      });
      columns.splice(3, 0, {
        Header: "Department",
        accessor: "department",
        // maxWidth: 120,
        Cell: ({ value }) => {
          const department = find(departments, {
            _id: isObject(value) ? value._id : value
          });
          return department ? department.code : "--";
        }
      });
      columns.splice(7, 0, {
        Header: "Date",
        accessor: "arrival_date",
        maxWidth: 120,
        filterable: false,
        Cell: (row) =>
          row.value ? (
            <span>{moment(row.value).utc().format("MM/DD/yyyy")}</span>
          ) : (
            "--"
          )
      });
      columns.splice(8, 0, {
        Header: "Actual",
        accessor: "actual_hrs",
        maxWidth: 100,
        Cell: (row) => (row.value ? row.value.toFixed(2) : "0.00")
      });
      columns.splice(9, 0, {
        Header: "Billable",
        accessor: "billable_hrs",
        maxWidth: 100,
        Cell: (row) => (row.value ? row.value.toFixed(2) : "0.00")
      });
    }

    if (ticketRedirect) {
      columns.push({
        Header: "",
        accessor: "support_ticket_id",
        maxWidth: 50,
        id: "support_ticket_id",
        className: "text-center",
        Cell: (row) => (
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            {(row.original.internal_notes?.trim() ||
              row.original.billing_description?.trim()) && (
              <React.Fragment>
                <a
                  id={row?.original?._id}
                  data-tooltip-variant={
                    this.props.auth.isNightMode ? "dark" : "light"
                  }
                >
                  <IoDocument className="icon" />
                </a>
                <ReactTooltip
                  anchorId={row?.original?._id}
                  className={`custom-tooltip ${
                    this.props.auth.isNightMode ? "dark" : "light"
                  }`}
                  place="left"
                >
                  <div>
                    <b>Internal Notes:</b>
                    <br />
                    {row.original.internal_notes
                      ? row.original.internal_notes
                      : "None"}
                    <br />
                    <br />
                    <b>Billing Notes:</b>
                    <br />
                    {row.original.billing_description
                      ? row.original.billing_description
                      : "None"}
                  </div>
                </ReactTooltip>
              </React.Fragment>
            )}
            {row.value && (
              <Link
                style={{ marginLeft: "1rem" }}
                to={`/app/support-tickets/add/${row.value}`}
              >
                <IoTicket className="theme-blue-color" />
              </Link>
            )}
          </div>
        )
      });
    }

    columns.push({
      Header: "",
      accessor: "_id",
      maxWidth: 80,
      filterable: false,
      sortable: false,
      Cell: (row) => {
        const isRecurring = !!row.original.recurring_id;
        return (
          <div className="text-center actions">
            <DropdownButton
              id={row.original._id}
              title={<IoEllipsisVertical />}
            >
              {/* <LinkContainer to={`/app/calls/${row.value}`}> */}
              <NavItem onClick={() => onClickView(row.value)}>
                <IoFolder />
                View
              </NavItem>
              {/* </LinkContainer> */}
              {/* only allow delete if "submitted" or "approved" status */}
              {/* only allow delete your own if employee or salesperson */}
              {row.original.stage &&
                (row.original.stage === status?.reserved?.id ||
                  row.original.stage === status?.completed?.id ||
                  row.original.stage?._id === status?.reserved?.id ||
                  row.original.stage?._id === status?.reserved?.id) &&
                !minimal &&
                (auth.maxRole > 2000 ||
                  row.original.assigned_to === auth.user._id) &&
                !(
                  call_type?._id === row.original.call_type && !auth.isAdmin
                ) && (
                  <NavItem
                    onClick={() => onClickDelete(row.value, isRecurring)}
                  >
                    <IoTrash className="brand-color" />
                    Delete
                  </NavItem>
                )}
            </DropdownButton>
          </div>
        );
      }
    });

    const props = {
      getTdProps: (state, rowInfo, column) => {
        if (!column.expander) {
          return {
            onClick: () => {
              if (
                column.id !== "_id" &&
                column.id !== "support_ticket_id" &&
                rowInfo?.original?._id
              ) {
                onClickView(rowInfo.original._id);
              }
            }
          };
        }
        return {};
      }
    };

    const serverSideProps = {
      manual: true,
      pages,
      onFetchData: this.fetchData,
      filtered
    };

    return (
      <ReactTable
        ref={(r) => (this.table = r)}
        {...props}
        {...(serverSide && serverSideProps)}
        className="-highlight calls"
        noDataText="No calls found"
        data={minimal ? data.slice(0, 3) : data}
        columns={columns}
        showPagination={!minimal}
        showPageSizeOptions={!isMobile}
        defaultPageSize={minimal ? 3 : defaultPageSize}
        onPageSizeChange={onPageSizeChange}
        defaultSorted={
          sorted || [
            {
              id: "arrival_date",
              asc: true
            }
          ]
        }
        LoadingComponent={() => <Loading active={loading} />}
        SubComponent={
          isMobile
            ? ({ original }) => {
                Object.keys(original).forEach((key) => {
                  original[key] = isObject(original[key])
                    ? original[key]._id
                    : original[key];
                });
                return (
                  <ResponsiveDataComponent
                    data={[
                      {
                        key: "Stage",
                        label: find(codes, { _id: original.stage }).label
                      },
                      {
                        key: "Assigned To",
                        label:
                          find(users, { _id: original.assigned_to })
                            .full_name || "--"
                      },
                      {
                        key: "Call Type",
                        label: find(codes, { _id: original.call_type })
                          ? find(codes, { _id: original.call_type }).label
                          : "--"
                      },
                      {
                        key: "Customer",
                        label:
                          find(customers, { _id: original.customer }).name ||
                          "--"
                      },
                      {
                        key: "Project",
                        label:
                          (find(projects, { _id: original.project }) &&
                            find(projects, { _id: original.project }).name) ||
                          "--"
                      },
                      {
                        key: "Actual Hours",
                        label: original.actual_hrs
                          ? original.actual_hrs.toFixed(2)
                          : "--"
                      },
                      {
                        key: "Billable Hours",
                        label: original.billable_hrs
                          ? original.billable_hrs.toFixed(2)
                          : "--"
                      },
                      {
                        key: "Department",
                        label:
                          find(departments, { _id: original.department })
                            .description || "--"
                      },
                      {
                        key: "Arrival Date",
                        label: original.arrival_date
                          ? formatDate(original.arrival_date, "M/d/yyyy")
                          : "--"
                      }
                    ]}
                  />
                );
              }
            : false
        }
      />
    );
  }
}

CallList.propTypes = {
  onClickDelete: PropTypes.func,
  filter: PropTypes.object,
  onChange: PropTypes.func,
  auth: PropTypes.object,
  customers: PropTypes.array,
  contracts: PropTypes.array,
  departments: PropTypes.array,
  data: PropTypes.array,
  actions: PropTypes.object,
  reloadData: PropTypes.func,
  fetchData: PropTypes.func,
  minimal: PropTypes.bool,
  onClickView: PropTypes.func,
  isMobile: PropTypes.bool,
  users: PropTypes.array,
  projects: PropTypes.array,
  codes: PropTypes.array,
  pages: PropTypes.number,
  serverSide: PropTypes.bool,
  filtered: PropTypes.object,
  sorted: PropTypes.array,
  setClick: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  defaultPageSize: PropTypes.number,
  fromProjectPage: PropTypes.bool,
  ticketRedirect: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    auth: state.reducers.auth,
    customers: state.reducers.customers,
    contracts: state.reducers.contracts,
    departments: state.reducers.departments,
    codes: state.reducers.codes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...userActions,
        ...codeActions,
        ...contractActions,
        ...departmentActions,
        ...projectActions,
        ...customerActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(CallList);
